import { Col, Row } from "antd";
import React from "react";
import ServiceProgramCard from "../../../biblio/Cards/ServiceProgramCard";
import DotsLoader from "../../../biblio/Loader/DotsLoader";
import useIsMobile from "../../../biblio/mobileVersion/useIsMobile";

interface Props {
  state: any;
  startIndex: number;
  endIndex: number;
  isMobile: any;
  isTablet: any;
}

const ExternalProgramCards = ({
  state,
  startIndex,
  endIndex,
  isMobile,
  isTablet,
}: Props) => {
  const { filteredProjects, toFilter, loading, isCompleted } = state;
  const isMobileWidth = useIsMobile();
  return (
    <div
      className="takaful--cases"
      style={{ width: isMobileWidth ? "99%" : "89%" }}
    >
      {loading ? (
        <div className="takaful--loading-projects-cases">
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : filteredProjects?.length > 0 ? (
        <Row
          dir="rtl"
          gutter={isMobile ? 32 : isTablet ? [32, 48] : 16}
          style={{ width: "100%" }}
        >
          {filteredProjects &&
            filteredProjects
              .slice(startIndex, endIndex)
              .map((item: any, index: number) => (
                <Col
                  key={item.id}
                  xxl={6}
                  xl={8}
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                >
                  <ServiceProgramCard
                    card={item}
                    index={item.id}
                    type="external"
                    isCompleted={isCompleted}
                  />
                </Col>
              ))}
        </Row>
      ) : toFilter ? (
        <p className="takaful--no-project-message">
          {`لا يوجد برامج تتوافق     
           مع البحث الذي قمت به`}
        </p>
      ) : (
        filteredProjects?.length === 0 && (
          <p className="takaful--no-project-message">{`لا يوجد 
             برامج`}</p>
        )
      )}
    </div>
  );
};

export default ExternalProgramCards;
